import { render, staticRenderFns } from "./TwoFactorAuth2.vue?vue&type=template&id=10cd8802&scoped=true&"
import script from "./TwoFactorAuth2.vue?vue&type=script&lang=js&"
export * from "./TwoFactorAuth2.vue?vue&type=script&lang=js&"
import style0 from "./TwoFactorAuth2.vue?vue&type=style&index=0&id=10cd8802&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10cd8802",
  null
  
)

export default component.exports